<template>
  <v-container>
    <v-row>
      <v-col>
        <p>Аутентификация клиента.</p>

        <div class="text-subtitle-1">Заголовки запроса</div>
        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Заголовок</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример значения</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Content-Type</td>
              <td>Тип содержимого в теле запроса</td>
              <td>application/x-www-form-urlencoded</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Типы запросов</div>

        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Пример</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <vue-code-highlight language="bash">
                  <pre>curl -s -X POST -H 'Accept: application/json' -H 'Content-Type: application/json' --data '{"login":"tester","password":"P@ssword"}' http://wapi-auth.mapmakers.ru/auth2/1.1/connect/token</pre>
                </vue-code-highlight>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Ответ</div>

        <v-simple-table class="table">
          <thead>
            <tr>
              <td>
                <b>Пример ответа</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <json-viewer :value="response" copyable boxed sort></json-viewer>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>


export default {
  
  data: function() {
    return {
      response: {
        access_token:
          "eyJhbGciOiJSUzI1NiIsImtpZCI6IjA0NTM1NDVjM2ZlOWFmMmExNjg0M2QxZDA2Nzc1N",
        expires_in: 172800,
        token_type: "Bearer"
      }
    };
  }
};
</script>